import * as React from "react";
import type { SVGProps } from "react";
const SvgVideoIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="video_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M170.667 512c0 188.672 152.661 341.333 341.333 341.333 188.672 0 341.333-152.661 341.333-341.333 0-188.672-152.661-341.333-341.333-341.333-188.672 0-341.333 152.661-341.333 341.333zm768 0c0 235.776-190.891 426.667-426.667 426.667S85.333 747.776 85.333 512 276.224 85.333 512 85.333 938.667 276.224 938.667 512zM373.333 624.939a85.333 85.333 0 0 0 130.56 72.362L667.52 595.03a85.333 85.333 0 0 0 0-144.725L503.893 348.032a85.333 85.333 0 0 0-130.56 72.363v204.544zm248.96-102.272L458.667 624.939V420.395l163.626 102.272z"
    />
  </svg>
);
export default SvgVideoIcon;
